import createClient from 'openapi-fetch';
import type { paths } from '@/types/api';

import type { FetchOptions } from 'openapi-fetch';

export type { FetchOptions };

export const useOpenApiClient = () => {
  const config = useRuntimeConfig();

  const client = createClient<paths>({
    baseUrl: config.public.apiEndpoint,
  });

  return { client };
};
